module.exports = __webpack_public_path__ + "static/headerRightBg-8412160f5fd4a921401e96fef8b2b2c9.png";